// extracted by mini-css-extract-plugin
export default {"root":"AppError_root__Weoj1"};